import { AppToolbarFeatureToggleConfig } from '../config/AppToolbarFeatureToggleConfig';
import { useFeatureToggle } from '@bizzabo/feature-toggle-client';

const DefaultToolEnabled = ({ children, appTool }) => {
    const featureToggleName = AppToolbarFeatureToggleConfig[appTool];
    const hasFeatureToggle = !!featureToggleName;
    const isFeatureToggleEnabled = useFeatureToggle(featureToggleName);
    return children({ isLoading: false, isEnabled: !hasFeatureToggle || isFeatureToggleEnabled });
};

export default DefaultToolEnabled;
